<template>
<div class="animated fadeIn">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>Training</h3>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('TITLE')}}</th>
                <th>{{$t('DESCRIPTION')}}</th>
                <th>{{$t('ACTION')}}</th>
                <th>{{$t('PROGRESS')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in response.root">
                <tr class=" table-ellipsis" :key="item.chapterId">
                  <td v-html="item.title"></td>
                  <td v-html="item.contentOut"></td>
                  <td>
                    <button type="button" class="btn-table btn-continue" @click="startExamModal(item)" v-if="item.previewComplet == 1 && item.answersSubmit == 0">{{$t('CONTINUE')}}</button>
                    <button type="button" class="btn-table" @click="startLesson(item)" v-if="item.previewComplet == 0">{{$t('STARTLESSON')}}</button>
                  </td>
                  <td>
                    <span>{{item.progress}}% {{(item.examProg > 86) ? '/ '+item.examProg+'%' : ''}}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formpreviewmodal" :title="$t('PREVIEWCHAPTERS')" ok-title="submit" hide-footer size='xl' centered no-close-on-backdrop>
    <div class="d-block">
      <formpreview v-bind:chapterContent="chapterContent" v-bind:traingnPage="trainingPage" v-bind:showReview="showReview" v-bind:previousPage="previousPage" v-bind:nextPage="nextPage" v-bind:backToChap="backToChap"></formpreview>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="primary mr-lg" @click="openChapterPages()" v-if="showReview">{{$t('REVIEWCHAPTES')}}</b-btn>
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="openPreviousPage()" v-if="previousPage">{{$t('PREVIOUSPAGE')}}</b-btn>
      <b-btn class="mt-3" variant="primary mr-lg" @click="openNextPage()" v-if="nextPage">{{$t('NEXTPAGE')}}</b-btn>
      <b-btn class="mt-3" variant="primary mr-lg" @click="startExamModal()" v-if="backToChap && chapterContent.quizId != null">{{$t('STARTEXAM')}}</b-btn>
      <b-btn class="mt-3" variant="primary mr-lg" @click="startExamModal()" v-if="backToChap && chapterContent.quizId == null">{{$t('COMPLETELESSON')}}</b-btn>
    </div>
  </b-modal>
  <b-modal ref="formexammodal" :title="$t('EXAMFORM')" ok-title="submit" hide-footer size='xl' no-close-on-backdrop>
    <div class="d-block" v-if="chapterContent.quizId != null">
      <formexam v-bind:quizPages="quizPages"></formexam>
    </div>
    <div class="d-block" v-else>
      {{$t('COMPLETELESSON')}}
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="success" @click="submitData(quizPages)">{{$t('SUBMIT')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/training/TrainingExamCustom'
import TrainingPagesApi from '@/api/training/TrainingPages'
import ExamApi from '@/api/exam/Exam'

import FormPreview from './FormPreview'
import FormExam from './FormExam'
export default
{
  name: 'TrainingChapters',
  components:
  {
    formpreview: FormPreview,
    formexam: FormExam
  },
  data: function()
  {
    return {
      response:
      {},
      chapterContent:
      {},
      trainingPage:
      {},
      quizPages: [],
      examId: null,
      showReview: true,
      previousPage: false,
      nextPage: false,
      backToChap: false,
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      },
      paginationPages:
      {
        query: '',
        currentPage: 1,
        limit: 1,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectTrainingChapter(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async startExamModal(item)
    {
      var me = this;
      try
      {
        me.$refs.formpreviewmodal.hide();
        me.paginationPages.currentPage = 1;

        if (typeof item !== 'undefined' && typeof item.chapterId !== 'undefined')
        {
            var chapterId = item.chapterId;
            me.chapterContent = item;
        }
        else var chapterId = me.paginationPages.chapterId

        var response = await ExamApi.selectExamRow(
        {
          'chapterId': chapterId
        });

        me.quizPages = response.root;

        var response = await ExamApi.selectSingleRow(
        {
          'trainingChapterId': chapterId
        });
        me.examId = response.examId;

        me.calcProgress('next');
        me.$refs.formexammodal.show();
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async startLesson(item)
    {
      var me = this;

      var data = await ExamApi.insertExam(
      {
        'trainingChapterId': item.chapterId
      });

      me.$refs.formpreviewmodal.show();

      me.examId = data.lastId;
      me.$set(me.paginationPages, 'chapterId', item.chapterId);

      me.chapterContent = item;

      me.showReview = true;
      me.previousPage = false;
      me.nextPage = false;
      me.backToChap = false;
    },
    async openChapterPages()
    {
      var me = this;
      try
      {
        var data = await TrainingPagesApi.selectRow(me.getParamsPages);
      }
      catch (e)
      {
        me.$notify.notice(e);
      }

      if (data.root.length != 0)
      {
        me.trainingPage = data;

        me.showReview = false;
        me.previousPage = (me.getParamsPages.currentPage == 1) ? false : true;
        me.nextPage = ((me.getParamsPages.limit + me.getParamsPages.start) == me.trainingPage.totalCount) ? false : true;
        if ((me.getParamsPages.limit + me.getParamsPages.start) == me.trainingPage.totalCount)
        {
          var data = await ExamApi.updateRow(
          {
            'id': me.examId,
            'previewComplet': 1
          });

          me.backToChap = true
        }
        else
        {
          me.backToChap = false
        }
      }
      else
      {
        me.showReview = false;
        me.backToChap = true;
      }
    },
    openPreviousPage()
    {
      var me = this;
      me.paginationPages.currentPage -= 1;
      me.openChapterPages();
      me.calcProgress('prev');
    },
    openNextPage()
    {
      var me = this;
      me.paginationPages.currentPage += 1;
      me.openChapterPages();
      me.calcProgress('next');
    },
    async calcProgress(key)
    {
      var me = this;
      try
      {
        var data = await ExamApi.calcProgress(
        {
          'examId': me.examId,
          'chapterId': me.getParamsPages.chapterId,
          'key' : key
        });

        await me.getData();
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        var data = await ExamApi.insertExamAnswers(
        {
          'examId': me.examId,
          'quizId': me.chapterContent.quizId,
          'answers': item
        });
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.$refs.formexammodal.hide();
          me.calcProgress('next');
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {

  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.trainingBlockId = me.$route.params.trainingBlockId;
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    },
    getParamsPages: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.paginationPages,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
